export default __webpack_public_path__ + "media/images/home/slide_winter_2026_sm-13aed3552ed0b12358decdb4ad6c2754.jpg";